import { Button, Container } from '@pwskills/rachnaui';
import { useContext, useEffect, useRef, useState } from 'react';
import StyleHtml from '@/HOCs/StyleHtml';
import { ChevronDown, ChevronUp } from '@pwskills/rachnaui/Icons';
import CategoryPageContext from '@/context/CategoryPageContext';
import SectionTitle from '@/components/common/SectionTitle';
import { useRouter } from 'next/router';
import { sanitizeDescriptionHtml } from '@/utils/GlobalCommonFunctions';

const SEOSection = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const { seoSection } = categoryDetails || {};

  const [contentHeight, setContentHeight] = useState<number>(0);
  const [showMore, setShowMore] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const maxContentHeight = 400; // Maximum height to show without expanding
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  useEffect(() => {
    if (containerRef.current) {
      const preElements = containerRef.current.querySelectorAll('div > pre');
      preElements.forEach((preElement) => {
        preElement.setAttribute('style', 'word-break: break-word; white-space: break-spaces;');
      });
      setContentHeight(containerRef.current.scrollHeight);
    }
  }, [showMore, seoSection]);
  const returnChildren = () => {
    return (
      <div className="flex flex-col gap-6 medium:gap-9">
        <SectionTitle upperText={seoSection?.headingOne} lowerText={seoSection?.headingTwo} isSeo />
        <div className="bg-blue-50 rounded-lg py-4 px-8 flex flex-col gap-4 !text-gray-850 !font-normal">
          <StyleHtml>
            <div
              ref={containerRef}
              style={{
                wordBreak: 'break-word',
                textJustify: 'auto',
                maxHeight: showMore ? 'none' : `${maxContentHeight}px`,
                overflowY: 'hidden',
                overflowX: 'hidden',
              }}
              dangerouslySetInnerHTML={{
                __html: sanitizeDescriptionHtml(seoSection?.body || ''),
              }}
            />
          </StyleHtml>

          {contentHeight > maxContentHeight && !showMore && (
            <div
              onClick={() => setShowMore(true)}
              className="flex gap-1 items-center self-end cursor-pointer"
            >
              <Button variant="text" className="text-orange-500 !p-0 !text-sm font-bold">
                Read More
              </Button>
              <ChevronDown className="!w-4 !h-4 text-orange-500" />
            </div>
          )}

          {showMore && (
            <div onClick={() => setShowMore(false)} className="flex gap-1 items-center self-end">
              <Button
                variant="text"
                className="text-orange-500 !p-0 !text-sm font-bold self-end cursor-pointer"
              >
                Read Less
                <ChevronUp className="!w-4 !h-4 text-orange-500" />
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  };
  return (
    <section className=" target:bg-white bg-white ">
      {isDashboard ? (
        <div className="flex flex-col gap-4">{returnChildren()}</div>
      ) : (
        <Container className="medium:!px-4 large:!px-20 py-9 medium:py-14 flex flex-col !gap-6 large:!gap-8 ">
          {returnChildren()}
        </Container>
      )}
    </section>
  );
};

export default SEOSection;
